import { type CloudflowBlueprint } from "../../types";

export const createBlueprintFilters = (blueprints: CloudflowBlueprint[] | undefined) => {
  const groupedFilter: Record<string, Record<string, number>> = {};

  blueprints?.forEach((blueprint) => {
    if (!blueprint.tags) {
      return;
    }

    // For each tag group, count the occurrences of each tag
    Object.entries(blueprint.tags).forEach(([tagGroup, tagValues]) => {
      tagGroup = tagGroup.toLowerCase();
      tagValues.forEach((tag) => {
        groupedFilter[tagGroup] = groupedFilter[tagGroup] || {};
        groupedFilter[tagGroup][tag] = (groupedFilter[tagGroup][tag] || 0) + 1;
      });
    });
  });

  const sortedGroupedFilter: Record<string, { tagValue: string; count: number }[]> = {};

  Object.keys(groupedFilter)
    .sort()
    .forEach((tagGroup) => {
      sortedGroupedFilter[tagGroup] = Object.keys(groupedFilter[tagGroup])
        .sort()
        .map((tag) => ({
          tagValue: tag,
          count: groupedFilter[tagGroup][tag],
        }));
    });

  return sortedGroupedFilter;
};
